export default [
    {
        path: '/region',
        props: true,
        component: () => import('@/views/Region'),
        children: [
            {
                path: 'create',
                component: () => import('@/components/Region/Create'),
                props: true,
            },
            {
                path: ':regionId',
                component: () => import('@/components/Region/Edit'),
                props: true,
            },
        ]
    },
];
